import { render, staticRenderFns } from "./articleTypeInfo.vue?vue&type=template&id=047011ad&"
import script from "./articleTypeInfo.vue?vue&type=script&lang=js&"
export * from "./articleTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports